import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {DictionariesService} from '../../services/dictionaries.service';

@Injectable()
export class DictionaryLeadSubagentAreaWorkResolve {

  constructor(private dict_helper: DictionariesService) { }

  resolve(route: ActivatedRouteSnapshot) {
    return this.dict_helper.get('Dict.get_subagent_area_work');
  }

}
